export default __webpack_public_path__ + "static/1-88fbd342ec69ca87756dd7e5e6fcc6cb.jpeg";